<template>
  <div>
    <base-message
        v-if="IClassroom.opponent.name"
        :message="message" :full-width="true">
      <div class="message-body is-block pk-result">
        <div class="message-header">
          学习对战
        </div>

        <div class="message-block-content">

          <v-transition name="slide-right">
            <opponents :show-win="true"></opponents>
          </v-transition>
          <v-transition name="slide-left">
            <div class="box">
              <div v-if="IClassroom.mySchool.score > IClassroom.opponent.score" class="media">
                <div class="media-left">
                  <img class="image" :src="IClassroom.opponent.image" alt="">
                </div>
                <div class="media-content">
                  <div class="title"><b>恭喜！成功战胜了{{ IClassroom.opponent.name }}</b></div>
                  <div v-html="IClassroom.opponent.cookbook" class="content"></div>
                </div>
              </div>
              <div v-else>
                <div class="title"><b class="is-text-link">真遗憾，未能战胜对手</b> <span
                    class="is-text-xs">(谜之声：据说抢先答对有额外加分)</span></div>
                <p>
                  <v-color-icon name="lock"></v-color-icon>
                  菜谱未解锁
                </p>
              </div>
              <br>
            </div>
          </v-transition>

          <div class="media is-vcenter is-success">
            <div class="media-left">
              <v-color-icon name="check" class="check-icon"></v-color-icon>
            </div>
            <div class="media-content">
              <div>{{ message.data.text }}</div>
              <div>
                <div class="buttons">
                  <button class="button is-success is-small"
                          @click="done">进入章节总结
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </base-message>
    <base-message
        v-else
        :message="message" :full-width="true">
      <div class="message-body is-block is-success text-message">
        <div class="media is-vcenter">
          <div class="media-left">
            <v-color-icon name="check" class="check-icon"></v-color-icon>
          </div>
          <div class="media-content">
            <div>{{ message.data.text }}</div>
            <div>
              <div class="buttons">
                <button class="button is-success is-small"
                        @click="done">进入章节总结
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </base-message>
  </div>
</template>

<script>
// import LoadingDot from './LoadingDot'
import BaseMessage from './BaseMessage'
import IClassroom from '@/components/classroom/lib/IClassroom'
import Opponents from '@/components/classroom/web/classmates/Opponents'

export default {
  props: ['message'],
  components: { BaseMessage, Opponents },
  data () {
    return {
      IClassroom,
      tipsContent: '',
      showTips: false
    }
  },
  async mounted () {
    const isWin = (IClassroom.opponent.name && IClassroom.opponent.score) ? (IClassroom.mySchool.score > IClassroom.opponent.score) : true

    if (isWin) {
      if (IClassroom.opponent.winNoty) {
        this.$noty.show(IClassroom.opponent.winNoty, 'success', { timeout: this.message.data.time || 3000 })
      }
    } else {
      if (IClassroom.opponent.failNoty) {
        this.$noty.show(IClassroom.opponent.failNoty, 'info', { timeout: this.message.data.time || 3000 })
      }
    }

    // 课程已经结束
    await this.$api.post(`/student/courses/${IClassroom.course._id}/groups/${IClassroom.group._id}/commit`, {
      win: isWin || (IClassroom.group.commits && IClassroom.group.win),
      group_logs: IClassroom.groupLogs
    })
    IClassroom.saySomething('恭喜，您已学完本小节全部内容，点击进入章节总结')
  },
  methods: {
    done () {
      IClassroom.enterGroup({ ...IClassroom.group, done: new Date() })
    }
  }
}
</script>

<style lang="stylus" scoped>
.buttons {
  margin-top .5rem
}

.check-icon {
  width 60px
  height 60px
  padding 10px
  overflow hidden
  border-radius 50%
  background $success
  color white
}

.is-success {
  padding 1rem
  border-radius 10px
  color $successFront
  background $successLight
}

.box {
  padding 1rem
}

.pk-result {
  user-select none

  .image {
    width 80px
    border-radius 10px
  }

  .title {
    font-size 20px
    margin-bottom .5rem
  }
}
</style>
